// src/CheckoutForm.js (Better UI)
import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [paymentSuccess, setPaymentSuccess] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setProcessing(true);

        if (!stripe || !elements) {
            setProcessing(false);
            return;
        }

        try {
            // This is where you would call your backend API to create a PaymentIntent
            const response = await fetch('http://localhost:4000/api/create-payment-intent', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount: 2000 }), // Example amount in cents
            });

            const data = await response.json();
            if (data.error) {
                setError(data.error);
                setProcessing(false);
                return;
            }

            const clientSecret = data.clientSecret;

            const payload = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                },
            });

            if (payload.error) {
                setError(`Payment failed: ${payload.error.message}`);
            } else {
                setError(null);
                setPaymentSuccess(true);
            }
        } catch (apiError) {
            setError('An error occurred. Please try again.');
        } finally {
            setProcessing(false);
        }
    };

    const cardElementOptions = {
        style: {
            base: {
                fontSize: '16px',
                color: '#32325d',
                fontFamily: 'Arial, sans-serif',
                '::placeholder': {
                    color: '#aab7c4',
                },
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a',
            },
        },
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <h2 style={styles.heading}>Complete Your Purchase</h2>
                <p style={styles.subHeading}>Enter your payment details below.</p>

                <form onSubmit={handleSubmit} style={styles.form}>
                    <div style={styles.formGroup}>
                        <label style={styles.label}>
                            Card Details
                            <div style={styles.inputContainer}>
                                <CardElement options={cardElementOptions} />
                            </div>
                        </label>
                    </div>

                    {error && <div style={styles.errorMessage}>{error}</div>}
                    {paymentSuccess && <div style={styles.successMessage}>Payment successful! 🎉</div>}

                    <button
                        type="submit"
                        disabled={!stripe || processing || paymentSuccess}
                        style={styles.button}
                    >
                        {processing ? 'Processing...' : 'Pay Now'}
                    </button>
                </form>
            </div>
        </div>
    );
};

// Inline styles for the component
const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f4f7f9',
        fontFamily: 'Arial, sans-serif',
    },
    card: {
        width: '100%',
        maxWidth: '500px',
        padding: '40px',
        backgroundColor: '#ffffff',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box',
    },
    heading: {
        fontSize: '24px',
        color: '#32325d',
        marginBottom: '8px',
        textAlign: 'center',
    },
    subHeading: {
        fontSize: '16px',
        color: '#8898aa',
        marginBottom: '24px',
        textAlign: 'center',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formGroup: {
        marginBottom: '20px',
    },
    label: {
        fontSize: '14px',
        color: '#6b7c93',
        fontWeight: 'bold',
        marginBottom: '8px',
        display: 'block',
    },
    inputContainer: {
        padding: '12px',
        border: '1px solid #e0e6ed',
        borderRadius: '4px',
        backgroundColor: '#f9fbfd',
        transition: 'border-color 0.2s ease',
    },
    button: {
        padding: '12px 24px',
        backgroundColor: '#6772e5',
        color: '#ffffff',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
        marginTop: '20px',
        // Hover effect for the button
        ':hover': {
            backgroundColor: '#5469d4',
        },
        ':disabled': {
            backgroundColor: '#aab7c4',
            cursor: 'not-allowed',
        },
    },
    errorMessage: {
        fontSize: '14px',
        color: '#fa755a',
        marginTop: '10px',
        textAlign: 'center',
    },
    successMessage: {
        fontSize: '16px',
        color: '#28a745',
        fontWeight: 'bold',
        marginTop: '10px',
        textAlign: 'center',
    },
};

export default CheckoutForm;